import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/nessimbtesh/repos/sdk/doc/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p>{`Noritex Styled Components SDK allows users to style your website using the necesary CSS only withouth having to import a big library.`}</p>
    <p>{`Regardless of the technologies and tools behind them, a successful design system follows these guiding principles:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`It’s consistent`}</strong>{`. The way components are built and managed follows a predictable pattern.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`It’s self-contained`}</strong>{`. Your design system is treated as a standalone dependency.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`It’s reusable`}</strong>{`. You’ve built components so they can be reused in many contexts.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`It’s accessible`}</strong>{`. Applications built with your design system are usable by as many people as possible.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`It’s robust`}</strong>{`. No matter the product or platform to which your design system is applied, it should perform with grace and minimal bugs.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "3-files"
    }}>{`3 Files`}</h2>
    <p>{`Elements.js`}</p>
    <p>{`Form.js`}</p>
    <p>{`Layout.js`}</p>
    <pre><code parentName="pre" {...{}}>{`import {
    Pagination,
    Filters,
    Tag,
    Tabs,
    Modal,
    Preloader,
    Dropdown,
    Breadcrumb,
    ArrowLeft,
    ArrowRight,
    Menu,
    Profile,
    Notify,
    Message
} from "noritex-sdk/Elements";

import {
    Control,
    Field,
    FieldBody,
    SelectBox,
    Checkbox,
    Radio
} from "noritex-sdk/Form";

import {
    Section,
    Box,
    Container,
    Row,
    Column,
    Columns,
    Content,
    Title,
    Subtitle,
    Heading,
    BlankState,
    LevelLeft,
    LevelRight,
    LevelItem,
    Level,
    SimpleCard,
    PageContent
} from "noritex-sdk/Layout";
`}</code></pre>
    <h2 {...{
      "id": "extend-the-components"
    }}>{`Extend the components`}</h2>
    <pre><code parentName="pre" {...{}}>{`import {
        Checkbox,
} from "noritex-sdk/Form";

const CheckboxExtended = styled(Checkbox)\`
    padding: 10px
\`;
`}</code></pre>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <p>{`Slider.js
// todo`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      